/** returns national transfers list
@return { Array }
*/
export const getTransfersList = state => state.transfersList
export const getTransfersListHasMore = state => state.transfersListHasMore

/** returns transfers status list
@return { Array }
*/
export const getTransfersStatusList = state => state.transfersStatusList

/** returns channels list
@return { Array }
*/
export const getChannelsList = state => state.channelsList

/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}
